import React, { createContext, useContext, useState } from 'react';
import {fetchPartner, CreatePartner,fetchServiceCategory} from '../../services/api';
import { CreateBranch, fetchBranches, fetchBranchId, UpdateBranch, fetchBranchadmin, ApproveBranch, ActivateBranch, deleteBranchById } from '../../services/Partner/PartnerApi';


const BranchContext = createContext();

export const BranchProvider = ({ children }) => {
    
    const [branches, setBranches] = useState([]);
    const [category, setcategory] = useState([]);
    const [currentBranch, setCurrentBranch] = useState(null);
    const [error, setError] = useState(null);
    const AddBranches = async (branches,files) => { 
       
        const result = await CreateBranch(branches,files);
        setBranches(result.data); 
        return result.data;
    };
    const FetchBranches = async() => {
       
        const response =await fetchBranches();
        setBranches(response.data);
        return response.data;
    };
    const FetchBranchAdmin = async () => {

        const response = await fetchBranchadmin();
        setBranches(response.data);
    };

    const FetchServiceCategory = async() => {
       
        const response =await fetchServiceCategory();
        setcategory(response.data);
    };
    const loadBranch = async (id) => {
        try {
           
            const data = await fetchBranchId(id); // Fetch single branch data
            setCurrentBranch(data[0]); // Set the current branch
            return data[0]
        } catch (error) {
            setError(error);
        }
    };
    const deleteBranch = async (id) => { 
        const result = await deleteBranchById(id);
        setBranches(result.data); 
    };
    const UpdateBranches = async (editBranch,files) => {    
       
        const result = await UpdateBranch(editBranch,files);
        setBranches(result); 
    };
    const ApproveBranchById = async (approve) => {    
        
        const result = await ApproveBranch(approve.id);
        setBranches(result); 
    };
    const ActivateBranchById = async (active,value) => {    
     
        const result = await ActivateBranch(active,value);
        setBranches(result); 
    };


  
      

    return (
        <BranchContext.Provider value={{ deleteBranch,FetchBranchAdmin,FetchServiceCategory,ActivateBranchById,ApproveBranchById,category,currentBranch,UpdateBranches,loadBranch, AddBranches,branches,FetchBranches} }>
            {children}
        </BranchContext.Provider>
    );
};

export const useBranchContext = () => useContext(BranchContext);
